import shortid from "shortid";

export function validateAndFixMjml(mjml: any) {
  // Sections
  let s_index = 0;
  for (const section of mjml.children[0].children) {
    // Fix section uid
    if (!section.uid) {
      section.uid = shortid.generate();
    }
    // Columns
    if (section.children) {
      let c_index = 0;
      for (const column of section.children) {
        // Fix section uid
        if (!column.uid) {
          column.uid = shortid.generate();
        }
        if (!column.attributes["vertical-align"]) {
          column.attributes["vertical-align"] = "top";
        }
        // Blocks
        if (column.children) {
          let b_index = 0;
          for (const block of column.children) {
            if (block === null) {
              mjml.children[0].children[s_index].children[
                c_index
              ].children.splice(b_index, 1);
              b_index--;
            } else {
              // Fix missing uid
              if (!block.uid) {
                block.uid = shortid.generate();
              }

              if (!block.attributes) {
                block.attributes = {};
              }

              // Fix missing container width
              if (!block.attributes.containerWidth) {
                block.attributes.containerWidth = 600;
              }

              // Fix missing image attributes
              if (["mj-image", "mj-gif"].indexOf(block.tagName) != -1) {
                if (!block.attributes.padding) {
                  block.attributes.padding = "25px 25px 25px 25px";
                }
                if (block.attributes.width && !block.attributes.widthPercent) {
                  block.attributes.widthPercent = Math.round(
                    (block.attributes.width / block.attributes.containerWidth) *
                      100
                  );
                }
                delete block.attributes["padding-top"];
                delete block.attributes["padding-bottom"];
                delete block.attributes["padding-left"];
                delete block.attributes["padding-right"];
              }

              // Fix missing button attributes
              if (block.tagName == "mj-button") {
                if (!block.attributes.align) {
                  block.attributes.align = "center";
                }
                if (!block.attributes.color) {
                  block.attributes.color = "#ffffff";
                }
              }

              // Fix missing divider attributes
              if (block.tagName == "mj-divider") {
                if (!block.attributes["border-color"]) {
                  block.attributes["border-color"] = "#ffffff";
                }
                if (block.attributes["padding"]) {
                  const padd_attr = block.attributes["padding"].split(" ");
                  block.attributes["padding-top"] = parseInt(padd_attr[0]);
                  block.attributes["padding-right"] = parseInt(padd_attr[1]);
                  block.attributes["padding-bottom"] = parseInt(padd_attr[2]);
                  block.attributes["padding-left"] = parseInt(padd_attr[3]);
                }
                if (block.attributes["padding-top"] == undefined) {
                  block.attributes["padding-top"] = 10;
                }
                if (block.attributes["padding-bottom"] == undefined) {
                  block.attributes["padding-bottom"] = 10;
                }
                if (block.attributes["padding-right"] == undefined) {
                  block.attributes["padding-right"] = 25;
                }
                if (block.attributes["padding-left"] == undefined) {
                  block.attributes["padding-left"] = 25;
                }
              }

              // Fix missing social attributes
              if (block.tagName == "mj-social") {
                if (!block.attributes.align) {
                  block.attributes.align = "center";
                }
              }

              //Fix missing px in fontsize
              if (
                block.tagName == "mj-text" &&
                block.attributes["font-size"] !== undefined
              ) {
                if (!block.attributes["font-size"].toString().includes("px")) {
                  block.attributes["font-size"] += "px";
                }
              }

              // Fix missing text attributes
              if (block.tagName == "mj-text") {
                delete block.attributes["link-color"];

                // Remove `draggable="false"` that accours in the tiny mce anchor tags and images
                block.content = block.content.replace(
                  /draggable="false"\s*/g,
                  ""
                );
              }

              // Fix proprietary mj-ecomail-video
              if (block.tagName == "mj-ecomail-video") {
                block.tagName = "mj-image";
                block.attributes.videoSrc = block.attributes.src;

                const regExp =
                  /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                const match = block.attributes.src.match(regExp);
                const youtubeId =
                  match && match[7].length == 11 ? match[7] : false;

                block.attributes.src =
                  "https://i.vimeocdn.com/filter/overlay?src=http://img.youtube.com/vi/" +
                  youtubeId +
                  "/0.jpg&src=https://integrationstore-b0c3f53658fe7a75.microservice.createsend.com/files/9392B9D9-F380-42FC-9571-7E109B7A1C26/youtube-play-button-overlay.png";
                block.isVideo = true;
              }
            }
            b_index++;
          }
        }
        c_index++;
      }
    }
    s_index++;
  }

  if (!mjml.style) {
    mjml.style = {};
  }

  if (!mjml.attributes) {
    mjml.attributes = {};
  }
  if (!mjml.attributes["mj-text"]) {
    mjml.attributes["mj-text"] = {};
  }
  if (!mjml.attributes["mj-text"]["line-height"]) {
    mjml.attributes["mj-text"]["line-height"] = 1.5;
  }
  if (!mjml.attributes["mj-button"]) {
    mjml.attributes["mj-button"] = {};
  }
  if (!mjml.attributes["mj-button"]["text-align"]) {
    mjml.attributes["mj-button"]["text-align"] = "center";
  }

  if (mjml.style.h1 === undefined) {
    mjml.style.h1 = {
      "font-size": "22px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.h2 === undefined) {
    mjml.style.h2 = {
      "font-size": "17px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.h3 === undefined) {
    mjml.style.h3 = {
      "font-size": "13px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.p === undefined) {
    mjml.style.p = {
      "font-size": "11px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.ul === undefined) {
    mjml.style.ul = {
      "font-size": "11px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.li === undefined) {
    mjml.style.li = {
      "font-size": "11px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (mjml.style.ol === undefined) {
    mjml.style.ol = {
      "font-size": "11px",
      "font-family": "Helvetica, Arial, sans-serif",
    };
  }

  if (
    mjml.style &&
    mjml.style.h1 &&
    (mjml.style.h1["font-size"] == null || mjml.style.h1["font-size"] === "")
  ) {
    mjml.style.h1["font-size"] = "22px";
  }
  if (
    mjml.style &&
    mjml.style.h2 &&
    (mjml.style.h2["font-size"] == null || mjml.style.h2["font-size"] === "")
  ) {
    mjml.style.h2["font-size"] = "17px";
  }
  if (
    mjml.style &&
    mjml.style.h3 &&
    (mjml.style.h3["font-size"] == null || mjml.style.h3["font-size"] === "")
  ) {
    mjml.style.h3["font-size"] = "13px";
  }
  if (
    mjml.style &&
    mjml.style.p &&
    (mjml.style.p["font-size"] == null || mjml.style.p["font-size"] === "")
  ) {
    mjml.style.p["font-size"] = "11px";
  }

  if (!mjml.feedBlocksApplyToAll) {
    mjml.feedBlocksApplyToAll = {};
  }

  return mjml;
}
